<template>
    <div>
      <el-dialog
        title="修改"
        center
        :visible.sync="updataVisible.show"
        :destroy-on-close="true"
        append-to-body
        @open="openDialog"
        width="30%"
      >
        <el-form label-position="left" :rules="rules" ref="ruleForm" label-width="80px" :model="formData">
          <el-form-item label="项目名称"  prop="projectName">
            <el-input v-model="formData.projectName"></el-input>
          </el-form-item>
          <el-form-item label="项目文件" prop="filePath">
            <el-upload
              class="upload-demo"
              drag
              action="/api/monitor/fileUpload/uploadImage"
              multiple
              :limit="1"
              :file-list="fileList"
              :on-success="successFile"
              :on-remove="removeFile"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
        </el-form>


        <span slot="footer" class="dialog-footer">
    <el-button @click="updataVisible.show = false">取 消</el-button>
    <el-button type="primary" @click="updataSubmit('ruleForm')">确 定</el-button>
  </span>
      </el-dialog>
    </div>
</template>

<script>
    import  API_CONFIG from "../../../../config/index"
    export default {
        name: "updataFile",
        props:{
            updataVisible:Object,
            dataInfo:Object
        },
        data(){
            return{
                rules: {
                    projectName: [
                        { required: true, message: '请输入项目名称', trigger: 'blur' },
                    ],
                    filePath: [
                        { required: true, message: '请添加项目文件', trigger: 'blur' },
                    ]
                },
                formData:{
                    projectName:"",
                    filePath:""
                },
                fileList:[]
            }
        },
        methods:{
            openDialog(){
                // console.log("api==",API_CONFIG.dev.proxyTable['/api'].target)
                let api = API_CONFIG.dev.proxyTable['/api'].target+'/monitor/image/'
                this.fileList=[]
                this.formData.id=this.dataInfo.id
                this.formData.createTime=this.dataInfo.createTime
                this.formData.projectName=this.dataInfo.projectName
                this.formData.filePath=this.dataInfo.filePath
                let fileName =  this.dataInfo.filePath.split('/')[this.dataInfo.filePath.split('/').length-1]
                // console.log(fileName,111)
                this.fileList.push({name:fileName,url:api+this.dataInfo.filePath})
                // console.log(/api/monitor/image)

            },
            successFile(file){
                if(file.status==200){
                    this.formData.filePath=file.datas.values
                    this.$message.success('文件上传成功')
                }else{
                    this.$message.error(file.message)
                }
            },
            removeFile(file){
                // console.log(file,1111)
                if(file.status=='success'){
                    this.formData.filePath=''
                    this.$message.success('文件删除成功')
                }else{
                    this.$message.error(file.message)
                }
            },
            updataSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/api/monitor/fileUpload/addFileData',this.formData).then(res=>{
                            if(res.data.status==200){
                                this.$message.success('更新成功')
                                this.$emit('upData')
                                this.formData.projectName=''
                                this.formData.filePath=''
                                this.updataVisible.show=false
                            }else{
                                this.$message.error(res.data.datas.values)
                            }
                        })
                    } else {
                        this.$message.warning('请检查必填项')
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/dialog/updataFile.vue